import Layout from "@/page/index/";
export default [
  {
    path: "/work",
    component: Layout,
    children: [
      {
        path: "dtTable",
        name: "服务清单管理",
        component: () => import("@/views/work/base/dtTable/index"),
      },
      {
        path: "dtTable/add",
        name: "新增服务清单",
        component: () => import("@/views/work/base/dtTable/add"),
      },
      {
        path: "dtTable/edit",
        name: "编辑服务清单",
        component: () => import("@/views/work/base/dtTable/edit"),
      },
      {
        path: "dtTable/view",
        name: "查看服务清单",
        component: () => import("@/views/work/base/dtTable/view"),
      },
      {
        path: "dynamicForm/formTypeManage",
        name: "表单类型管理",
        component: () =>
          import("@/views/work/dynamicForm/formTypeManage/index"),
      },
      {
        path: "dynamicForm/formManage",
        name: "表单管理",
        component: () => import("@/views/work/dynamicForm/formManage/index"),
      },
      {
        path: "dynamicForm/formManage/add",
        name: "新增表单",
        component: () => import("@/views/work/dynamicForm/formManage/add"),
      },
      {
        path: "dynamicForm/formManage/edit",
        name: "编辑表单",
        component: () => import("@/views/work/dynamicForm/formManage/edit"),
      },
      {
        path: "dynamicForm/formManage/view",
        name: "查看表单",
        component: () => import("@/views/work/dynamicForm/formManage/view"),
      },
      {
        path: "waterProject/purWaterGoods",
        name: "净水产品管理",
        component: () =>
          import("@/views/work/waterProject/purWaterGoods/index"),
        meta: {
          keepAlive: true,
        },
      },
      {
        path: "waterProject/purWaterGoods/add",
        name: "新增净水产品",
        component: () => import("@/views/work/waterProject/purWaterGoods/add"),
      },
      {
        path: "waterProject/purWaterGoods/edit",
        name: "编辑净水产品",
        component: () => import("@/views/work/waterProject/purWaterGoods/edit"),
      },
      {
        path: "waterProject/purWaterGoods/view",
        name: "查看净水产品",
        component: () => import("@/views/work/waterProject/purWaterGoods/view"),
      },
      {
        path: "waterProject/qr",
        name: "净水安装码",
        component: () => import("@/views/work/waterProject/qr/index"),
      },
      {
        path: "waterProject/qr/qrDetails",
        name: "净水安装码详情",
        component: () => import("@/views/work/waterProject/qr/qrDetails/index"),
      },
      {
        path: "waterProject/merchants",
        name: "净水报单管理",
        component: () => import("@/views/work/waterProject/merchants/index"),
        meta: {
          keepAlive: true,
        },
      },
      {
        path: "waterProject/engineer",
        name: "净水服务单管理",
        component: () => import("@/views/work/waterProject/engineer/index"),
        meta: {
          keepAlive: true,
        },
      },
      {
        path: "waterProject/reminder",
        name: "系统配置",
        component: () => import("@/views/work/waterProject/reminder/index"),
      },
      {
        path: "waterProject/engineer/evaluateInfo",
        name: "客户评价详情",
        component: () =>
          import("@/views/work/waterProject/engineer/evaluateInfo/index"),
      },
      {
        // 优惠券管理
        path: "waterProject/coupon",
        name: "优惠券管理",
        component: () => import("@/views/work/waterProject/coupon/index"),
      },
      {
        path: "waterProof/purWaterGoods",
        name: "防水产品管理",
        component: () => import("@/views/work/waterProof/purWaterGoods/index"),
      },
      {
        path: "waterProof/purWaterGoods/add",
        name: "新增防水产品",
        component: () => import("@/views/work/waterProof/purWaterGoods/add"),
      },
      {
        path: "waterProof/purWaterGoods/edit",
        name: "编辑防水产品",
        component: () => import("@/views/work/waterProof/purWaterGoods/edit"),
      },
      {
        path: "waterProof/purWaterGoods/view",
        name: "查看防水产品",
        component: () => import("@/views/work/waterProof/purWaterGoods/view"),
      },
      {
        path: "waterProof/configPrice",
        name: "防水价格配置",
        component: () => import("@/views/work/waterProof/configPrice/index"),
      },
      {
        // 优惠券管理
        path: "waterProof/coupon",
        name: "防水优惠券管理",
        component: () => import("@/views/work/waterProof/coupon/index"),
      },
      {
        path: "waterProof/driverShopAgent",
        name: "绑定司机账号",
        component: () => import("@/views/work/waterProof/driverShopAgent/index"),
      },
      {
        path: "waterProof/qr",
        name: "防水安装码",
        component: () => import("@/views/work/waterProof/qr/index"),
      },
      {
        path: "waterProof/qr/qrDetails",
        name: "防水安装码详情",
        component: () => import("@/views/work/waterProof/qr/qrDetails/index"),
      },
      {
        path: "waterProof/merchants",
        name: "商户防水报单管理",
        component: () => import("@/views/work/waterProof/merchants/index"),
        meta: {
          keepAlive: true,
        },
      },
      {
        path: "waterProof/merchants/edit",
        name: "编辑防水商户报单",
        component: () => import("@/views/work/waterProof/merchants/edit"),
      },
      {
        path: "waterProof/merchants/view",
        name: "查看防水商户报单",
        component: () => import("@/views/work/waterProof/merchants/view"),
      },
      {
        path: "waterProof/manageProject",
        name: "防水服务项目管理",
        component: () =>
          import("@/views/work/waterProof/manageProject/index"),
      },
      {
        path: "waterProof/engineer",
        name: "防水服务单管理",
        component: () => import("@/views/work/waterProof/engineer/index"),
      },
      {
        path: "waterProof/materialAccount",
        name: "防水材料账户管理",
        component: () => import("@/views/work/waterProof/materialAccount/index"),
      },
      {
        path: "waterProof/materialAccountV2",
        name: "防水材料账户管理V2",
        component: () => import("@/views/work/waterProof/materialAccountV2/index"),
      },
      {
        path: "waterProof/merchantPrice",
        name: "商家价格管理",
        component: () => import("@/views/work/waterProof/merchantPrice/index"),
      },
      {
        path: "waterProof/combo",
        name: "材料套餐组合配置",
        component: () => import("@/views/work/waterProof/combo/index"),
      },
      {
        path: "waterProof/materialStatistics",
        name: "材料领取统计",
        component: () =>
          import("@/views/work/waterProof/materialStatistics/index"),
      },
      // 查看材料明细
      {
        path: "waterProof/materialStatistics/view",
        name: "查看材料明细",
        component: () =>
          import("@/views/work/waterProof/materialStatistics/view"),
      },
      {
        path: "waterProof/reminder",
        name: "系统配置",
        component: () => import("@/views/work/waterProof/reminder/index"),
      },
      {
        path: "waterProof/engineer/engineerDetails",
        name: "防水服务单详情",
        component: () =>
          import("@/views/work/waterProof/engineer/engineerDetails/index"),
      },
      {
        path: "waterProof/engineer/evaluateInfo",
        name: "客户评价详情",
        component: () =>
          import("@/views/work/waterProof/engineer/evaluateInfo/index"),
      },
      {
        path: "waterProof/declarationCode",
        name: "查看报单验证码",
        component: () =>
          import("@/views/work/waterProof/declarationCode/index"),
      },
      {
        path: "ceiling/purWaterGoods",
        name: "吊顶产品管理",
        component: () => import("@/views/work/ceiling/purWaterGoods/index"),
      },
      {
        path: "ceiling/purWaterGoods/add",
        name: "新增吊顶产品",
        component: () => import("@/views/work/ceiling/purWaterGoods/add"),
      },
      {
        path: "ceiling/purWaterGoods/edit",
        name: "编辑吊顶产品",
        component: () => import("@/views/work/ceiling/purWaterGoods/edit"),
      },
      {
        path: "ceiling/purWaterGoods/view",
        name: "查看吊顶产品",
        component: () => import("@/views/work/ceiling/purWaterGoods/view"),
      },
      {
        path: "ceiling/merchants",
        name: "商户吊顶报单管理",
        component: () => import("@/views/work/ceiling/merchants/index"),
        meta: {
          keepAlive: true,
        },
      },
      {
        path: "ceiling/merchants/edit",
        name: "编辑吊顶商户报单",
        component: () => import("@/views/work/ceiling/merchants/edit"),
      },
      {
        path: "ceiling/merchants/view",
        name: "查看吊顶商户报单",
        component: () => import("@/views/work/ceiling/merchants/view"),
      },
      {
        path: "ceiling/engineer/engineerDetails",
        name: "吊顶服务单详情",
        component: () =>
          import("@/views/work/ceiling/engineer/engineerDetails/index"),
      },
      {
        path: "eliveryOrder/ceilingView",
        name: "吊顶提货单",
        component: () => import("@/views/work/eliveryOrder/ceilingView"),
      },
      {
        path: "ceiling/engineer/evaluateInfo",
        name: "客户评价详情",
        component: () =>
          import("@/views/work/ceiling/engineer/evaluateInfo/index"),
      },
      {
        path: "ceiling/materialStatistics",
        name: "吊顶材料领取统计",
        component: () =>
          import("@/views/work/ceiling/materialStatistics/index"),
      },
      // 查看材料明细
      {
        path: "ceiling/materialStatistics/view",
        name: "吊顶材料领取明细",
        component: () =>
          import("@/views/work/ceiling/materialStatistics/view"),
      },
      {
        path: "ceiling/materialAccount",
        name: "吊顶材料账户管理",
        component: () => import("@/views/work/ceiling/materialAccount/index"),
      },
      {
        path: "pipeline/merchants",
        name: "管道商户报单管理",
        component: () => import("@/views/work/pipeline/merchants/index"),
        meta: {
          keepAlive: true,
        },
      },
      {
        path: "pipelineTesting/merchants",
        name: "管道试压报单管理",
        component: () => import("@/views/work/pipelineTesting/index"),
        meta: {
          keepAlive: true,
        },
      },
      {
        path: "engineeringProject/manageProject",
        name: "工程服务项目管理",
        component: () =>
          import("@/views/work/engineeringProject/manageProject/index"),
      },
      {
        path: "engineeringProject/manageProject/add",
        name: "新增工程服务项目",
        component: () =>
          import("@/views/work/engineeringProject/manageProject/add"),
      },
      {
        path: "engineeringProject/manageProject/edit",
        name: "编辑工程服务项目",
        component: () =>
          import("@/views/work/engineeringProject/manageProject/edit"),
      },
      {
        path: "engineeringProject/manageProject/view",
        name: "查看工程服务项目",
        component: () =>
          import("@/views/work/engineeringProject/manageProject/view"),
      },
      {
        path: "engineeringProject/merchants",
        name: "商户工程报单管理",
        component: () =>
          import("@/views/work/engineeringProject/merchants/index"),
        // 页面保持
        meta: {
          keepAlive: true,
        },
      },
      {
        path: "engineeringProject/merchants/edit",
        name: "编辑商户工程报单",
        component: () =>
          import("@/views/work/engineeringProject/merchants/edit"),
      },
      {
        path: "engineeringProject/merchants/view",
        name: "查看商户工程报单",
        component: () =>
          import("@/views/work/engineeringProject/merchants/view"),
      },
      {
        path: "engineeringProject/engineer",
        name: "工程服务单管理",
        component: () =>
          import("@/views/work/engineeringProject/engineer/index"),
        meta: {
          keepAlive: true,
        },
      },
      {
        path: "engineeringProject/engineer/engineerDetails",
        name: "工程服务单",
        component: () =>
          import(
            "@/views/work/engineeringProject/engineer/engineerDetails/index"
          ),
      },
      {
        path: "engineeringProject/engineer/engineerDetails/details",
        name: "工程服务单详情",
        component: () =>
          import(
            "@/views/work/engineeringProject/engineer/engineerDetails/details"
          ),
      },
      {
        path: "engineeringProject/engineer/evaluateInfo",
        name: "工程服务评价详情",
        component: () =>
          import("@/views/work/engineeringProject/engineer/evaluateInfo/index"),
      },
      {
        path: "serviceItem",
        name: "服务项目管理",
        component: () => import("@/views/work/base/serviceItem/index"),
      },
      {
        path: "serviceItem/add",
        name: "新增服务项目",
        component: () => import("@/views/work/base/serviceItem/add"),
      },
      {
        path: "serviceItem/edit",
        name: "编辑服务项目",
        component: () => import("@/views/work/base/serviceItem/edit"),
      },
      {
        path: "serviceItem/view",
        name: "查看服务项目",
        component: () => import("@/views/work/base/serviceItem/view"),
      },
      {
        path: "eliveryOrder",
        name: "提货单管理",
        component: () => import("@/views/work/eliveryOrder/index"),
        meta: {
          keepAlive: true,
        },
      },
      {
        path: "eliveryOrder/view",
        name: "提货单详情",
        component: () => import("@/views/work/eliveryOrder/view"),
      },
      {
        path: "eliveryOrder/serviceDiary",
        name: "提货单详情",
        component: () => import("@/views/work/eliveryOrder/serviceDiary"),
      },
      {
        path: "serviceDraw",
        name: "服务抽成管理",
        component: () => import("@/views/work/base/serviceDraw/index"),
      },
      {
        path: "serviceDraw/add",
        name: "新增服务抽成",
        component: () => import("@/views/work/base/serviceDraw/add"),
      },
      {
        path: "serviceDraw/edit",
        name: "编辑服务抽成",
        component: () => import("@/views/work/base/serviceDraw/edit"),
      },
      {
        path: "serviceDraw/view",
        name: "查看服务抽成",
        component: () => import("@/views/work/base/serviceDraw/view"),
      },
      {
        path: "serviceWarranty",
        name: "服务质保管理",
        component: () => import("@/views/work/base/serviceWarranty/index"),
      },
      {
        path: "serviceWarranty/add",
        name: "新增服务质保",
        component: () => import("@/views/work/base/serviceWarranty/add"),
      },
      {
        path: "serviceWarranty/edit",
        name: "编辑服务质保",
        component: () => import("@/views/work/base/serviceWarranty/edit"),
      },
      {
        path: "serviceWarranty/view",
        name: "查看服务质保",
        component: () => import("@/views/work/base/serviceWarranty/view"),
      },
      {
        path: "projectItem",
        name: "工程项目管理",
        component: () => import("@/views/work/base/projectItem/index"),
      },
      {
        path: "projectItem/add",
        name: "新增工程项目",
        component: () => import("@/views/work/base/projectItem/add"),
      },
      {
        path: "projectItem/edit",
        name: "编辑工程项目",
        component: () => import("@/views/work/base/projectItem/edit"),
      },
      {
        path: "projectItem/view",
        name: "查看工程项目",
        component: () => import("@/views/work/base/projectItem/view"),
      },

      {
        path: "projectDynamic",
        name: "工程服务清单管理",
        component: () => import("@/views/work/base/projectDynamic/index"),
      },
      {
        path: "projectDynamic/add",
        name: "新增工程服务清单",
        component: () => import("@/views/work/base/projectDynamic/add"),
      },
      {
        path: "projectDynamic/view",
        name: "查看工程服务清单",
        component: () => import("@/views/work/base/projectDynamic/view"),
      },
      {
        path: "projectDynamic/edit",
        name: "编辑工程服务清单",
        component: () => import("@/views/work/base/projectDynamic/edit"),
      },
      {
        path: "projectDraw",
        name: "工程抽成管理",
        component: () => import("@/views/work/base/projectDraw/index"),
      },
      {
        path: "projectDraw/add",
        name: "新增工程抽成",
        component: () => import("@/views/work/base/projectDraw/add"),
      },
      {
        path: "projectDraw/view",
        name: "查看工程抽成",
        component: () => import("@/views/work/base/projectDraw/view"),
      },
      {
        path: "projectDraw/edit",
        name: "编辑工程抽成",
        component: () => import("@/views/work/base/projectDraw/edit"),
      },
      {
        path: "projectWarranty",
        name: "工程质保管理",
        component: () => import("@/views/work/base/projectWarranty/index"),
      },
      {
        path: "projectWarranty/add",
        name: "新增工程质保",
        component: () => import("@/views/work/base/projectWarranty/add"),
      },
      {
        path: "projectWarranty/view",
        name: "查看工程质保",
        component: () => import("@/views/work/base/projectWarranty/view"),
      },
      {
        path: "projectWarranty/edit",
        name: "编辑工程质保",
        component: () => import("@/views/work/base/projectWarranty/edit"),
      },
      {
        path: "projectService",
        name: "工程服务管理",
        component: () => import("@/views/work/base/projectService/index"),
      },
      {
        path: "projectService/add",
        name: "新增工程服务",
        component: () => import("@/views/work/base/projectService/add"),
      },
      {
        path: "projectService/workOrderInfo",
        name: "工程工单信息详情",
        component: () =>
          import("@/views/work/base/projectService/workOrderInfo"),
      },
      {
        path: "projectService/view",
        name: "查看工程服务",
        component: () => import("@/views/work/base/projectService/view"),
      },
      {
        path: "projectService/edit",
        name: "编辑工程服务",
        component: () => import("@/views/work/base/projectService/edit"),
      },
      {
        path: "serviceOrder",
        name: "服务单管理",
        component: () => import("@/views/work/base/serviceOrder/index"),
        meta: {
          keepAlive: true,
        },
        /* beforeEnter: (to, from, next) => {
          console.log(to, from);
          if (from.name == "查看服务单") {
            to.meta.keepAlive = true;
            to.meta.savedPosition = document.documentElement.scrollTop || document.body.scrollTop;
          } else {
            to.meta.keepAlive = false;
          }
          next();
        }, */
        /* meta: {
          keepAlive: true,
        }, */
      },
      {
        path: "serviceOrder/view",
        name: "查看服务单",
        component: () => import("@/views/work/base/serviceOrder/view"),
      },
      {
        path: "appointmentCard",
        name: "预约卡管理",
        component: () => import("@/views/work/base/appointmentCard/index"),
      },
      // 预约卡详情
      {
        path: "appointmentCard/detail",
        name: "预约卡详情",
        component: () => import("@/views/work/base/appointmentCard/detail"),
      },
      {
        path: "afterSales",
        name: "售后单管理",
        component: () => import("@/views/work/afterSales/index"),
      },
      {
        path: "paymentConfig",
        name: "支付配置",
        component: () => import("@/views/work/paymentConfig/index"),
      },
      {
        path: "attendance/config",
        name: "考勤罚款配置",
        component: () => import("@/views/work/attendance/config"),
        meta: { keepAlive: true },
      },
      /* ,{
        path: "afterSales/afterSalesDetails",
        name: "售后服务单",
        component: () => import("@/views/work/afterSales/afterSalesDetails/index"),
      },
      {
        path: "afterSales/afterSalesDetails/details",
        name: "售后服务单详情",
        component: () =>
          import("@/views/work/afterSales/afterSalesDetails/details"),
      },
      {
        path: "afterSales/afterSalesevaluateInfo",
        name: "售后服务评价详情",
        component: () =>
          import("@/views/work/afterSales/afterSaleseValuateInfo/index"),
      }, */
    ],
  },
];
